import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Table } from "@itandi/itandi-bb-ui/Table";
import { Tbody } from "@itandi/itandi-bb-ui/Tbody";
import { Th } from "@itandi/itandi-bb-ui/Th";
import { Thead } from "@itandi/itandi-bb-ui/Thead";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import type { ReactNode } from "react";
import React from "react";
import { NotificationListRow } from "~/components/common/notifications/settings/NotificationListRow";
import type { NskResponse } from "~/models/Api";
import type { LineUserAccount } from "~/models/LineUserAccount";
import type {
	Notification,
	NotificationEdit,
	NotificationTargetType
} from "~/models/Notification";
import type { Status } from "~/models/Status";
import type { Subtype } from "~/models/Subtype";

type Props = DeepReadonly<{
	handleDestroy: (notification: Notification) => Promise<NskResponse>;
	handleMutate: () => Promise<void>;
	handleUpdate: (
		notification: NotificationEdit,
		notificationId: number
	) => Promise<NskResponse>;
	lineUserAccounts?: LineUserAccount[] | null;
	notifications: Notification[];
	statuses: Status[];
	subtypes?: Subtype[] | null;
	type: NotificationTargetType;
	useLineNotification: boolean;
}>;

export function NotificationList({
	type,
	notifications,
	statuses,
	subtypes = null,
	lineUserAccounts = null,
	useLineNotification,
	handleMutate,
	handleUpdate,
	handleDestroy
}: Props) {
	const renderRow = React.useCallback(
		(notification: Notification): ReactNode => (
			<NotificationListRow
				handleDestroy={handleDestroy}
				handleMutate={handleMutate}
				handleUpdate={handleUpdate}
				key={notification.id}
				lineUserAccounts={lineUserAccounts}
				notification={notification}
				statuses={statuses}
				subtypes={subtypes}
				type={type}
				useLineNotification={useLineNotification}
			/>
		),
		[
			handleDestroy,
			handleMutate,
			handleUpdate,
			lineUserAccounts,
			statuses,
			subtypes,
			type,
			useLineNotification
		]
	);
	return (
		<Table>
			<Thead>
				<Tr>
					<Th>
						<Label weight="bold">案件種別</Label>
					</Th>
					<Th>
						<Label weight="bold">通知トリガー</Label>
					</Th>
					<Th>
						<Label weight="bold">案件状況</Label>
					</Th>
					<Th>
						<Label weight="bold">通知タイプ</Label>
					</Th>
					<Th>
						<Label weight="bold">通知先</Label>
					</Th>
					<Th>
						<Label weight="bold">通知タイトル</Label>
					</Th>
					<Th width="6rem">
						<Label weight="bold">操作</Label>
					</Th>
				</Tr>
			</Thead>
			<Tbody>{notifications.map(renderRow)}</Tbody>
		</Table>
	);
}
